import React from 'react';
import { ProgressSpinner } from "primereact/progressspinner";
import { Loading } from './AnalyticTabs.styled';

export const LoadingSpinner = () => (
    <Loading>
        <ProgressSpinner />
    </Loading>
);
